@if (formGroup && standingData) {
    <form [formGroup]="formGroup" data-uiid="task-detail-form">
        @if (showWorkflowComment) {
            <div class="form-group global-comment">
                <br />
                <pre class="readonly-comment">{{ model.workflowComment }}</pre>
                <hr />
            </div>
        }
        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ "tasks.details" | transloco }}</div>
            <div class="detail-page-card-body padded cerrix-control-sm form-group-styling">
                <div class="row">
                    <div class="col-12 col-xl-6 left-block">
                        <div class="row">
                            <div class="col">
                                <cerrix-textfield
                                    [fieldLabel]="'tasks.name' | transloco"
                                    dataUiid="task-detail-name"
                                    identifier="taskNameInput"
                                    formControlName="name"
                                    [placeholder]="'tasks.requiredPlaceholder' | transloco"
                                    [readonly]="!permissions?.canEdit"
                                ></cerrix-textfield>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col">
                                <label for="responsibleSelect">{{ "tasks.responsibles" | transloco }}</label>
                                <ng-select
                                    data-uiid="task-responsible"
                                    s
                                    id="responsibleSelect"
                                    name="responsibleSelect"
                                    [multiple]="true"
                                    [items]="standingData.responsibles"
                                    [placeholder]="'tasks.requiredPlaceholder' | transloco"
                                    formControlName="responsibles"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    [closeOnSelect]="false"
                                    [readonly]="!permissions?.canEdit"
                                >
                                </ng-select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col">
                                <cerrix-textarea
                                    [fieldLabel]="'tasks.description' | transloco"
                                    dataUiid="task-detail-description"
                                    identifier="taskDescriptionInput"
                                    [rows]="4"
                                    formControlName="description"
                                    [readonly]="!permissions?.canEdit"
                                ></cerrix-textarea>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col">
                                <label>{{ "tasks.columnActionDate" | transloco }}</label>
                                <date-input
                                    data-uiid="task-detail-actiondate"
                                    formControlName="actionDate"
                                ></date-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col">
                                <label for="notificationsSelect">{{ "tasks.notifications" | transloco }}</label>
                                <ng-select
                                    data-uiid="task-notifications"
                                    id="notificationsSelect"
                                    name="notificationsSelect"
                                    [multiple]="true"
                                    [items]="standingData.notifications"
                                    formControlName="notifications"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    [closeOnSelect]="false"
                                    [readonly]="!permissions?.canEdit"
                                >
                                </ng-select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-xl-6 right-block">
                        <div class="row">
                            <div class="form-group col">
                                <label for="linkedTypeSelect">{{ "tasks.linkedTypeLabel" | transloco }}</label>
                                <ng-select
                                    data-uiid="task-linkedtype"
                                    s
                                    id="linkedTypeSelect"
                                    name="linkedTypeSelect"
                                    [multiple]="true"
                                    [items]="standingData.taskTypes"
                                    [placeholder]="'tasks.requiredPlaceholder' | transloco"
                                    formControlName="linkedTypeIds"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    (change)="linkedTypesChanged($event)"
                                    [closeOnSelect]="false"
                                    [readonly]="!permissions?.canEdit"
                                >
                                </ng-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col">
                                <label for="reviewersSelect">{{ "tasks.reviewers" | transloco }}</label>
                                <i
                                    class="far fa-info-circle mx-2"
                                    [matTooltip]="'tasks.reviewersTooltip' | transloco"
                                ></i>
                                <ng-select
                                    data-uiid="task-series-reviewers"
                                    name="reviewersSelect"
                                    [multiple]="true"
                                    [items]="standingData.reviewers"
                                    formControlName="reviewerIds"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    [closeOnSelect]="false"
                                >
                                </ng-select>
                            </div>
                        </div>
                        @if (
                            standingData.taskScores && model.taskScoreOption !== TaskScoreOptions.No
                        ) {
                            <div class="row">
                                <div class="form-group col">
                                    @if (model.taskScoreOption === TaskScoreOptions.Required) {
                                        <label for="taskScoreSelect">{{
                                            "tasks.scoreRequiredFieldLabel" | transloco
                                        }}</label>
                                    } @else {
                                        <label for="taskScoreSelect">{{
                                            "tasks.scoreLabel" | transloco
                                        }}</label>
                                    }
                                    @if (standingData.taskScores.length > 0) {
                                        <cerrix-select
                                            data-uiid="task-score"
                                            id="score"
                                            name="score"
                                            [multiple]="false"
                                            [getDataMethod]="standingData.taskScores"
                                            formControlName="score"
                                            bindLabel="Name"
                                            bindValue="ID"
                                            [closeOnSelect]="true"
                                        >
                                        </cerrix-select>
                                    } @else {
                                        <p [innerHTML]="'tasks.noScoresDefinedMessage' | transloco"></p>
                                    }
                                </div>
                            </div>
                        }
                        <div class="row">
                            <div class="form-group col">
                                <label for="taskCommentsInput">{{
                                    "tasks.commentsFieldLabel" | transloco
                                }}</label>
                                <i
                                    class="far fa-info-circle mx-2"
                                    [matTooltip]="'tasks.commentsTooltip' | transloco"
                                >
                                </i>
                                <cerrix-textarea
                                    dataUiid="task-detail-comments"
                                    identifier="taskCommentsInput"
                                    [rows]="4"
                                    formControlName="comments"
                                    [readonly]="!permissions?.canEditComment"
                                ></cerrix-textarea>
                            </div>
                        </div>
                        @if (model.guid) {
                            <div class="row">
                                <div class="form-group col">
                                    <label for="taskEvidenceInput">{{
                                        "tasks.evidenceLabel" | transloco
                                    }}</label>
                                    <i
                                        class="far fa-info-circle mx-2"
                                        [matTooltip]="'tasks.evidenceTooltip' | transloco"
                                    >
                                    </i>
                                    <document-manager-old
                                        [Label]="''"
                                        [disabled]="model.workflowState == TaskWorkflowStatus.Done"
                                        [(Documents)]="model.Documents"
                                        [permissions]="permissions.documentPermissions"
                                        [DocumentTypeTargets]="targetModule"
                                    >
                                    </document-manager-old>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </form>
} @else {
    <div class="detail-page-card">
        <div class="detail-page-card-title">{{ "tasks.taskDetailsLoadingTitle" | transloco }}</div>
        <div class="detail-page-card-body padded cerrix-control-sm">
            <div class="fancy-loader submodule"></div>
        </div>
    </div>
}
